import { TypeCode } from '../bti/types';

import MCGI from './types/MCGI.jpg';
import MCGT from './types/MCGT.jpg';
import MCVI from './types/MCVI.jpg';
import MCVT from './types/MCVT.jpg';
import MSGI from './types/MSGI.jpg';
import MSGT from './types/MSGT.jpg';
import MSVI from './types/MSVI.jpg';
import MSVT from './types/MSVT.jpg';
import NCGI from './types/NCGI.jpg';
import NCGT from './types/NCGT.jpg';
import NCVI from './types/NCVI.jpg';
import NCVT from './types/NCVT.jpg';
import NSGI from './types/NSGI.jpg';
import NSGT from './types/NSGT.jpg';
import NSVI from './types/NSVI.jpg';
import NSVT from './types/NSVT.jpg';

export const TYPE_IMAGES: Partial<Record<TypeCode, string>> = {
  MCGI,
  MCGT,
  MCVI,
  MCVT,
  MSGI,
  MSGT,
  MSVI,
  MSVT,
  NCGI,
  NCGT,
  NCVI,
  NCVT,
  NSGI,
  NSGT,
  NSVI,
  NSVT,
};
